import { request } from "../request";

export default {
	requestReset: ({ email }) => request("requestReset", "POST", { email }),
	resetPassword: ({ token, password }) => request("resetPassword", "POST", { token, password, password_confirmation: password }),
	verifyLogin: ({ email, password }) => request("auth/login", "POST", { email, password }),
	autoLogin: ({ autologin }) => request("auth/autologin", "POST", { autologin }),
	logout: () => request("auth/logout", "POST")
};